import React, { ReactElement } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import Layout from '../Layout';
import routes from '../../routing/routes';
import GlobalErrors from '../../module/GlobalErrors';
import SecuredPage from '../../module/SecuredPage';
import PageHeadingWithBackButton from '../../module/PageHeadingWithBackButton';
import { DolozkaZlucitelnosti } from '../../module/SprievodnyDokument/CreateFromForm';
import {
  useLegislativnyMaterialDetail,
} from '../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';
import {
  createDolozkaZlucitelnostiClient,
} from '../../client/external/evidencnaaplikacia/dolozkaZlucitelnostiClient';
import initFormData from '../../function/initEmptyDolozkaZlucitelnosti';
import isPredbeznaInformacia from '../../function/isPredbeznaInformacia';
import SuccessMessages from '../../module/SuccessMessages';
import { useClient } from '../../context/ClientStatusContext';

const DolozkaZlucitelnostiCreatePage = (): ReactElement => {
  const location = useLocation();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION);

  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    wrapClient: createDolozkaZlucitelnosti,
  } = useClient(createDolozkaZlucitelnostiClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Doložka zlučiteľnosti',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          hasOpravneniePracovneKroky={materialDetail?.hasOpravnenieSprievodneDokumenty}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
            <>
              <PageHeadingWithBackButton
                headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                heading="Doložka zlučiteľnosti"
                withBackLink
              />
              <DolozkaZlucitelnosti
                onSubmit={createDolozkaZlucitelnosti}
                material={materialDetail}
                initFormData={initFormData()}
              />
            </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default DolozkaZlucitelnostiCreatePage;
